"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _ = require('lodash');

var PropTypes = require('prop-types');

var React = require('react');

var dropDownHelpers = require('../../util/dropDownHelpers');

var compose = require('../../hoc/compose');

var displayNames = require('../displayNames');

var TextInput = require('../textInput');

var DropDown = require('../dropDown');

var dynamicPartRegex = function dynamicPartRegex(prefix, suffix) {
  var escapedPrefix = _.escapeRegExp(prefix);

  var escapedSuffix = _.escapeRegExp(suffix);

  return new RegExp("".concat(escapedPrefix, "((?:(?!(?:").concat(escapedPrefix, "|").concat(escapedSuffix, ")).)*)").concat(escapedSuffix), 'g'); // anything between prefix and suffix that does not contain them
};

var DynamicField = /*#__PURE__*/function (_React$Component) {
  _inherits(DynamicField, _React$Component);

  var _super = _createSuper(DynamicField);

  function DynamicField(props) {
    var _this;

    _classCallCheck(this, DynamicField);

    _this = _super.call(this, props);
    _this.state = {
      showOverlay: true,
      valueCandidate: _this.props.value
    };

    _this.getRootCssClasses = function () {
      return ['dynamic-field-container', _this.props.horizontalView ? 'horizontal' : 'vertical', !_this.props.prefix && !_this.props.horizontalView ? 'un-prefixed' : '', _this.props.disabled ? 'disabled' : ''].join(' ');
    };

    _this.onInputBlur = function () {
      return _this.setState({
        showOverlay: true
      }, _this.props.onBlur || _.noop);
    };

    _this.onInputFocus = function () {
      return _this.setState({
        showOverlay: false
      });
    };

    _this.getOverlay = function (inputValue) {
      var decoratedValue = inputValue.split(dynamicPartRegex(props.dynamicPartPrefix, props.dynamicPartSuffix)).map(function (v, i) {
        var isDynamicPart = i % 2 === 1;

        var isValueDynamicOption = _.find(props.options, function (option) {
          return option === v || option.value === v;
        });

        var valueToDisplayInOverlay = isDynamicPart && !isValueDynamicOption ? props.dynamicPartPrefix + v + props.dynamicPartSuffix : v;
        var partProps = isDynamicPart && isValueDynamicOption ? {
          key: "text".concat(i),
          className: 'dynamic-text',
          'data-prefix': props.dynamicPartPrefix,
          'data-suffix': props.dynamicPartSuffix
        } : {
          key: "text".concat(i),
          className: 'static-text'
        };
        return React.createElement('pre', partProps, valueToDisplayInOverlay);
      });
      var className = ['overlay', _this.state.showOverlay ? '' : 'hidden'].join(' ');
      return React.createElement('div', {
        className: className
      }, decoratedValue);
    };

    _this.onValueStateChange = function (val) {
      _this.setState({
        valueCandidate: val
      });
    };

    _this.onValidationStatus = function (isValid) {
      if (isValid) {
        _this.props.onChange(_this.state.valueCandidate);
      }
    };

    _this.onChange = _this.props.validator || _this.props.asyncValidator ? _this.onValueStateChange : _this.props.onChange;
    return _this;
  }

  _createClass(DynamicField, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.value !== this.state.valueCandidate && nextProps.value !== this.props.value) {
        this.setState({
          valueCandidate: nextProps.value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.getClassName(this.getRootCssClasses()),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement("div", {
        className: "field-container"
      }, this.props.prefix ? /*#__PURE__*/React.createElement("span", {
        key: "inputPrefix",
        className: "input-prefix"
      }, this.props.translateIfNeeded(this.props.prefix)) : null, /*#__PURE__*/React.createElement("div", {
        className: "text-container"
      }, /*#__PURE__*/React.createElement(TextInput, {
        className: _({
          'dynamic-field-input': true,
          'hidden-text': this.state.showOverlay
        }).transform(function (res, value, key) {
          if (value) {
            res.push(key);
          }
        }, []).join(' '),
        value: this.state.valueCandidate,
        validator: this.props.validator,
        asyncValidator: this.props.asyncValidator,
        invalidMessage: this.props.invalidMessage,
        allowInvalidChange: true,
        placeholder: this.props.placeholder,
        shouldTranslate: this.props.shouldTranslate,
        disabled: this.props.disabled,
        onChange: this.onChange,
        isValid: this.props.isValid,
        onValidationStatus: this.onValidationStatus,
        onBlur: this.onInputBlur,
        onFocus: this.onInputFocus
      }), /*#__PURE__*/React.createElement("span", {
        className: "overlay-container"
      }, this.getOverlay(this.state.valueCandidate)))), this.props.disabled ? null : /*#__PURE__*/React.createElement(DropDown, {
        className: "dynamic-field-drop-down",
        key: "dynamicOptions",
        onToggle: this.props.onToggle,
        placeholder: this.props.addDynamicPartButtonLabel,
        shouldTranslate: false,
        optionsContainerClassName: "dynamic-field-options",
        options: this.props.options,
        onChange: this.props.onFieldAdd,
        hasArrowIcon: false,
        openOnSelected: false
      }));
    }
  }]);

  return DynamicField;
}(React.Component);

var validatorType = PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.func), PropTypes.func]);
DynamicField.displayName = displayNames.DYNAMIC_FIELD;
DynamicField.propTypes = {
  /** The field value  */
  value: PropTypes.string.isRequired,

  /** Callback function, triggered on field value change */
  onChange: PropTypes.func.isRequired,

  /** Callback function, triggered when adding a dynamic value */
  onFieldAdd: PropTypes.func.isRequired,

  /** The expected string for the dynamic value to begin with */
  dynamicPartPrefix: PropTypes.string,

  /** The expected string for the dynamic value to end with */
  dynamicPartSuffix: PropTypes.string,

  /** The text to be displayed on the button opener of the dynamic values list */
  addDynamicPartButtonLabel: PropTypes.string.isRequired,

  /** The list of dynamic values */
  options: dropDownHelpers.PropTypes.options,

  /** Callback function, triggered when field loose focus */
  onBlur: PropTypes.func,

  /** Callback function, triggered on dynamic values options open/close */
  onToggle: PropTypes.func,

  /** When set to true the dynamic values options will be places horizontally, next to the field */
  horizontalView: PropTypes.bool,

  /** Prefix to be displayed before the field value */
  prefix: PropTypes.string,

  /** Placeholder for the field value */
  placeholder: PropTypes.string,

  /** When set to true, field can not be modified an get a disabled appearance */
  disabled: PropTypes.bool,

  /** Deprecated */
  isValid: PropTypes.bool,

  /** The error message to be displayed when the validation fails */
  invalidMessage: PropTypes.string,

  /** Callback function for validation, triggered on input change. Should return true / false */
  validator: validatorType,
  asyncValidator: validatorType
};
DynamicField.defaultProps = {
  prefix: '',
  placeholder: '',
  horizontalView: false,
  disabled: false,
  dynamicPartPrefix: '{',
  dynamicPartSuffix: '}'
};
module.exports = compose(DynamicField);